import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=25a42688&scoped=true"
import script from "./ImageSlider.vue?vue&type=script&lang=js"
export * from "./ImageSlider.vue?vue&type=script&lang=js"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&id=25a42688&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a42688",
  null
  
)

export default component.exports